// utils/exportToExcel.js
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const OwnerExport = (owner, filename = 'owner_export.xlsx') => {
  const ownerName =
    owner?.ownerType === 'company' ? `${owner?.companyInfo?.companyName} (${owner?.name})` : owner?.name;

  const privateOwner = {
    FirstName: owner?.privateOwner?.firstName,
    LastName: owner?.privateOwner?.lastName,
    Gender: owner?.privateOwner?.gender,
    BirthDate: owner?.privateOwner?.birthDate,
    BirthPlace: owner?.privateOwner?.birthPlace,
    FiscalCode: owner?.privateOwner?.fiscalCode,
    Email: owner?.privateOwner?.email,
    DocumentType: owner?.privateOwner?.documentType,
    Phone: owner?.privateOwner?.phone,
    Address: owner?.privateOwner?.address,
    DocumentNumber: owner?.privateOwner?.documentNumber,
  };

  const companyOwner = {
    FirstName: owner?.companyOwner?.firstName,
    LastName: owner?.companyOwner?.lastName,
    Gender: owner?.companyOwner?.gender,
    BirthDate: owner?.privateOwner?.birthDate,
    BirthPlace: owner?.privateOwner?.birthPlace,
    FiscalCode: owner?.privateOwner?.fiscalCode,
    DocumentType: owner?.privateOwner?.documentType,
    DocumentNumber: owner?.privateOwner?.documentNumber,
  };

  const companyInfo = {
    CompanyName: owner?.companyInfo?.companyName,
    CompanyType: owner?.companyInfo?.companyType,
    VatNumber: owner?.companyInfo?.vatNumber,
    FiscalCode: owner?.companyInfo?.fiscalCode,
    ReaNumber: owner?.companyInfo?.reaNumber,
    TaxStatus: owner?.companyInfo?.taxStatus,
    Email: owner?.companyInfo?.email,
    PEC: owner?.companyInfo?.pec,
    CompanyPhone: owner?.companyInfo?.phone,
    LegalAddress: owner?.companyInfo?.legalAddress,
    ElectronicInvoiceCode: owner?.companyInfo?.electronicInvoiceCode,
  };

  const baseData = {
    Name: ownerName,
    OwnerType: owner?.ownerType,
    ContractDuration: owner?.contractDuration,
    TerminationNotice: owner?.terminationNotice,
    Signed: owner?.createdAt ? new Date(owner.createdAt).toLocaleDateString() : '',
    Language: owner?.language,
    ManagementFee: owner?.percentage,
    AccountHolder: owner?.bankInfo?.accountHolder,
    Bank: owner?.bankInfo?.bank,
    IBAN: owner?.bankInfo?.iban,
    OwnerNotes: owner?.ownerNotes,
  };

  const exportData = [
    {
      ...baseData,
      ...(owner?.ownerType !== 'company' ? privateOwner : {}),
      ...(owner?.ownerType === 'company' ? companyOwner : {}),
      ...(owner?.ownerType === 'company' ? companyInfo : {}),
    },
  ];

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Property');

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  const file = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  saveAs(file, filename);
};
